import { SxProps } from '@mui/material';

export const SubNavLinkListSx: SxProps = {
  marginTop: '0 !important',
  paddingTop: '0',
};
